import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import MercurXBackButton from '../../components/MercurXBackButton/MercurXBackButton';
import MercurXProjectDetailInputs from
  '../../components/MercurXProjectDetailInputs/MercurXProjectDetailInputs';

function EditNFTProject() {
  const history = useHistory();
  const location = useLocation();
  const project = location.state?.project;

  if (!project) {
    history.goBack();
    return null;
  }

  return (
    <div>
      <MercurXBackButton buttonText="Back to NFT project list" />
      <div className="text-fs-head-sm">Edit NFT project</div>
      <MercurXProjectDetailInputs
        isEdit={true}
        showProject={true}
        showToken={false}
        showSocial={true}
        showContract={false}
      />
    </div>
  );
}

export default connect(null, null)(EditNFTProject);
